module.exports = __webpack_public_path__ + "static/img/img_qingyun_footer_text.97cea6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_qingyun_footer_text.png
// module id = JVFV
// module chunks = 1